import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { AllAccommodationTypeTermsQuery } from '@custom/schema';

export const useAccommodationTypeTerms = () => {
  return useStaticQuery(graphql(AllAccommodationTypeTermsQuery));
};
